"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var color_1 = __importDefault(require("color"));

var mobileStylesHelper_1 = __importDefault(require("../assets/mobileStylesHelper"));

function rgba(baseColor, alpha) {
  return color_1.default('transparent').mix(color_1.default(baseColor), alpha).toString();
}

var inlineBlock = 'inline-block';

exports.styles = function (_a) {
  var x05 = _a.x05,
      x8 = _a.x8,
      x10 = _a.x10,
      x12 = _a.x12,
      colorBgSecondary = _a.colorBgSecondary,
      colorBgPopup = _a.colorBgPopup,
      sizeControlHeight = _a.sizeControlHeight,
      sizeBorderWidth = _a.sizeBorderWidth,
      sizeBorderRadius = _a.sizeBorderRadius;
  return __assign({
    container: {
      display: inlineBlock,
      maxWidth: '100%',
      position: 'relative',
      overflow: 'hidden'
    },
    blockContainer: {
      display: 'block'
    },
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap'
    },
    leftHiddenWrapper: {
      float: 'right'
    },
    fade: {
      position: 'absolute',
      top: 0,
      zIndex: 999,
      width: 88,
      height: '100%'
    },
    mobileFade: {
      display: 'none'
    },
    leftFade: {
      left: 0,
      background: "linear-gradient(270deg, " + rgba(colorBgPopup.normal, 0) + ", " + rgba(colorBgPopup.normal, 1) + ")"
    },
    rightFade: {
      right: 0,
      background: "linear-gradient(90deg, " + rgba(colorBgPopup.normal, 0) + ", " + rgba(colorBgPopup.normal, 1) + ")"
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      top: 'calc(50% - 16px)',
      left: 0,
      width: x8,
      height: x8,
      zIndex: 1000
    },
    input: {
      flex: '0 0 auto',
      display: inlineBlock,
      width: '26px',
      borderRadius: x05,
      margin: '0 2px',
      '& input': {
        padding: '0 0 0 8px',
        lineHeight: sizeControlHeight - 2 * sizeBorderWidth + "px",
        appearance: 'textfield'
      },
      '& input::-webkit-inner-spin-button': {
        appearance: 'none'
      }
    },
    digit: {
      flex: '0 0 auto',
      display: inlineBlock,
      height: sizeControlHeight,
      width: 26,
      background: colorBgSecondary.normal,
      lineHeight: sizeControlHeight + "px",
      borderRadius: sizeBorderRadius,
      textAlign: 'center',
      margin: '0 2px'
    }
  }, mobileStylesHelper_1.default({
    '& $input': {
      height: x12
    },
    '& $digit': {
      height: x12,
      lineHeight: '48px'
    },
    '& input': {
      lineHeight: '46px'
    },
    '& $icon': {
      top: 'calc(50% - 20px)',
      width: x10,
      height: x10
    },
    '& $mobileFade': {
      display: 'flex'
    }
  }));
};